import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import './generalMenu.scss';

import {
    Target,
    Users,
    BriefCase,
} from "../../../uiKit/assets/svg/icons";
import MenuItem from "./MenuItem";

import { getUser, refreshToken } from "../../../redux/state/accountSlice";
import { setScreenWidth } from "../../../redux/state/commonSlice";

const MENU = [
    { title: 'Campaigns', url: '/campaigns', icon: Target },
    { title: 'Communities', url: '/communities/all', icon: Users },
    { title: 'Jobs', url: '/jobs', icon: BriefCase },
]

const CommunityMenu = ({ closeMenu = () => { } }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const { campaignId } = useParams();

    const userDetails = useSelector(state => state.account.userDetails, shallowEqual);
    const community = useSelector(state => state.community.community, shallowEqual);
    const notFound = useSelector(state => state.campaign.notFound, shallowEqual);
    const notFoundCommon = useSelector(state => state.common.notFound, shallowEqual);

    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);

    useEffect(() => {
        window.addEventListener('resize', () => dispatch(setScreenWidth(window.innerWidth)));
        return () => window.removeEventListener('resize', () => dispatch(setScreenWidth(window.innerWidth)))
    }, [screenWidth, dispatch])

    useEffect(() => {
        const storedToken = window.localStorage.getItem('token');
        if (!!storedToken) {
            const parsedtoken = JSON.parse(storedToken);
            const interval = setInterval(() => {
                const token = window.localStorage.getItem('refresh-token');
                if (!!token) {
                    dispatch(refreshToken(token));
                }
            }, [(parsedtoken.expires_in - 10) * 1000])

            return () => clearInterval(interval)
        }
    }, [dispatch])

    useEffect(() => {
        if (!userDetails.id) {
            dispatch(getUser())
            // .then(unwrapResult)
            // .then(() => dispatch(setLoaded({ type: 'account', value: true })))
        }
    }, [userDetails, dispatch])

    useEffect(() => {
        if (notFoundCommon) {
            history.push('/not-found')
        }
    }, [notFoundCommon, history])

    useEffect(() => {
        if (notFound && !!campaignId && !!community.id && !community.role) {
            history.push(`/campaigns/campaign-completed/${community.id}/${campaignId}`)
        }
    }, [notFound, history, campaignId, community?.role, community?.id])

    return (
        MENU.map((item, index) => (
            <MenuItem
                key={index}
                Icon={item.icon}
                title={item.title}
                url={item.url}
                total={item.total}
                onClick={() => closeMenu()}
            />
        ))
    )
}

export default CommunityMenu;